import React from 'react';
import { CtaButton } from './CtaButton';
export function HeroSection() {
  const scrollToOffer = () => {
    const el = document.getElementById('precio-final');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <section className="pt-14 pb-4 md:pt-28 md:pb-14 px-6 max-w-5xl mx-auto text-center" data-id="element-120">
      <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-navy leading-tight mb-6" data-id="element-121">
        ¿Sentís que tu cerebro funciona{' '}
        <span className="italic text-accent" data-id="element-122">"a media máquina"</span>?
      </h1>

      <h2 className="text-xl md:text-2xl font-medium text-navy/80 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-123">
        Despejá la <strong className="text-navy" data-id="element-124">niebla mental</strong> en{' '}
        <strong className="text-navy" data-id="element-125">3 días</strong> y recuperá la{' '}
        <strong className="text-navy" data-id="element-126">energía</strong> que dabas por perdida.
      </h2>

      <p className="text-lg text-navy/70 mb-6 md:mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-127">
        Descubrí por qué el{' '}
        <strong className="text-navy" data-id="element-128">cansancio crónico</strong>{' '}
        <strong className="text-navy" data-id="element-129">
          nada tiene que ver con tu edad, sino con el agotamiento de tu
          combustible celular
        </strong>
        . Un método de{' '}
        <span className="text-accent font-semibold" data-id="element-130">reinicio biológico</span>{' '}
        para recuperar el enfoque y la ligereza{' '}
        <strong className="text-accent font-semibold" data-id="element-131">
          sin procesos complejos ni dependencia química externa
        </strong>
        .
      </p>

      <CtaButton onClick={scrollToOffer} className="text-2xl" data-id="element-132">
        QUIERO RESETEAR MI SISTEMA AHORA
      </CtaButton>
      <p className="mt-3 text-xs md:text-sm text-navy/45 text-center" data-id="element-133">
        Más de 470 personas ya reiniciaron su sistema biológico con este
        protocolo.
      </p>
    </section>;
}